import React from 'react';
import { Box, SxProps } from '@mui/material';
import { ExplorerEntityTypes } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default function ContentGridContainer({
  children,
  sx,
  supportTypes,
}: {
  children: React.ReactNode;
  sx?: SxProps;
  supportTypes: ExplorerEntityTypes[];
}) {
  const { isLessLaptop } = useBooleanScreens();

  console.log(supportTypes);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isLessLaptop
          ? '1fr auto'
          : `548fr 100fr 100fr  ${
              supportTypes.includes(ExplorerEntityTypes.FILE) ? '120fr' : ''
            } 0px`,
        gridAutoFlow: 'row',
        width: 1,
        alignItems: 'stretch',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  );
}
